import Layout from 'HorizontalMenu/Menu'
import React from 'react'
import { Link } from 'react-router-dom'
import { Col, Container, Navbar, Row } from 'reactstrap'

const ImportHistory = () => {
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Row className='pb-2'>
                        <Col sm={2} className="d-flex align-items-center">
                            {/* <button color='primary' className='btn btn-primary' onClick={() => { window.location.assign("users") }}>
                                <i className="bx bx-chevron-left me-1" /> Back
                            </button> */}
                            <Link className="btn_size_cstm mr-1 btn btn-primary" to="/users">
                                <i className="bx bx-chevron-left me-1" /> Back
                            </Link>
                        </Col>
                        <Col lg={9} className="d-flex align-items-center">
                            <h2 className="page_title pos-center text-uppercase mb-0">
                                History
                            </h2>
                        </Col>
                    </Row>
                    <div className="table-responsive">
                        <table className="table mb-2">
                            <thead className="table-light">
                                <tr>
                                    <th className="p-2 align middle sr-no-width">#</th>
                                    <th className="p-2 align middle" style={{ width: '50%' }}>File</th>
                                    <th className="p-2 align middle" style={{ width: '20%' }}>Date</th>
                                    <th className="p-2 align middle" style={{ width: '20%' }}>Imported</th>
                                    <th className="p-2 align middle" style={{ width: '10%' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="p-2 align middle">1</td>
                                    <td className="p-2 align middle">First user import file </td>
                                    <td className="p-2 align middle">27/12/24</td>
                                    <td className="p-2 align middle">30</td>
                                    <td className="p-2 align middle">
                                        <Link className="btn btn-soft-primary waves-effect waves-light" to="/users/history/1">
                                            <i className="bx bx-detail font-size-16 align-middle"></i>
                                        </Link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ImportHistory